/* Klar zum Ja – kleine Helfer, alle auf kzj-* Sektionen begrenzt, Event-Delegation */
(function () {
  'use strict';
  if (window.__kzjInit) return; window.__kzjInit = true;
  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  onReady(function () {
    /* Sticky-Kaufleiste (mobil): erscheint, sobald der Hero aus dem Bild ist, verschwindet am Paket-Block und am Seitenende */
    var sticky = document.querySelector('.kzj-sticky');
    if (sticky && 'IntersectionObserver' in window) {
      document.body.classList.add('kzj-has-sticky');
      var hero = document.querySelector('.kzj-hero');
      var hide = [].slice.call(document.querySelectorAll('.kzj-pakete-section, .kzj-cta-section, .footer'));
      var heroOut = false, overHide = false;
      function update() { sticky.classList.toggle('is-visible', heroOut && !overHide); }
      if (hero) new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(hero);
      else heroOut = true;
      if (hide.length) {
        var io = new IntersectionObserver(function (entries) {
          overHide = hide.some(function (el) { return el.__kzjVisible; });
          update();
        }, { threshold: 0.15 });
        hide.forEach(function (el) {
          new IntersectionObserver(function (e) { el.__kzjVisible = e[0].isIntersecting; io.takeRecords(); overHide = hide.some(function (x) { return x.__kzjVisible; }); update(); }, { threshold: 0.15 }).observe(el);
        });
      }
      update();
    }

    /* Galerie-Pfeile */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-kzj-scroll]');
      if (!btn) return;
      var track = btn.closest('.kzj-galerie').querySelector('.kzj-galerie__track');
      var item = track.querySelector('.kzj-galerie__item');
      var step = item ? item.getBoundingClientRect().width + 16 : 320;
      track.scrollBy({ left: btn.getAttribute('data-kzj-scroll') === 'next' ? step : -step, behavior: 'smooth' });
    });

    /* FAQ: immer nur ein Eintrag offen (angenehmer auf dem Handy) */
    document.addEventListener('toggle', function (ev) {
      var d = ev.target;
      if (!(d instanceof HTMLDetailsElement) || !d.closest('.kzj-faq') || !d.open) return;
      d.closest('.kzj-faq').querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);

    /* Sanftes Scrollen zu Ankern (#pakete, #faq …) mit Kopfzeilen-Abstand */
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      var id = a.getAttribute('href').replace(/^\/?#/, '');
      var el = id && document.getElementById(id);
      if (!el) return;
      ev.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + id);
    });

    /* Kaufformulare: Doppelklick-Schutz */
    document.addEventListener('submit', function (ev) {
      var f = ev.target.closest('form[data-kzj-buy]');
      if (!f) return;
      var b = f.querySelector('button[type="submit"]');
      if (b) { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Einen Moment …'; setTimeout(function () { b.disabled = false; b.textContent = b.dataset.label; }, 6000); }
    });
  });
})();
